import { onsiteStaffRoutes, privateRoutes, publicRoutes } from './routesConfig';
import RoutesRenderer from './RoutesRenderer';

const Routes = (): JSX.Element => {
  return <RoutesRenderer {...{ privateRoutes, publicRoutes, onsiteStaffRoutes }} />;
};

export default Routes;
